import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import api from "axios.config";

import {
  LoginError,
  LoginParams,
  LoginPasswordParams,
  LoginPasswordSuccess,
  LoginSuccess,
  MyAccountDetailsSuccess,
  ResendOTPError,
  ResendOTPParams,
  ResendOTPSuccess,
  VerifyOTPError,
  VerifyOTPParams,
  VerifyOTPSuccess,
} from "./auth.type";

export const useLoginOTP = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: LoginSuccess) => void;
  onError: (error: AxiosError<LoginError>) => void;
}) =>
  useMutation<LoginSuccess, AxiosError<LoginError>, LoginParams>({
    mutationFn: async (data) =>
      api
        .post(`${process.env.REACT_APP_API_OTP_LOGIN}`, data)
        .then((r) => r.data),
    onSuccess,
    onError,
  });

export const useLoginPassword = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: LoginPasswordSuccess) => void;
  onError: (error: AxiosError<LoginError>) => void;
}) =>
  useMutation<
    LoginPasswordSuccess,
    AxiosError<LoginError>,
    LoginPasswordParams
  >({
    mutationFn: async (data) =>
      api
        .post(`${process.env.REACT_APP_API_PASSWORD_LOGIN}`, data)
        .then((r) => r.data),
    onSuccess,
    onError,
  });

export const useVerifyOTP = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: VerifyOTPSuccess) => void;
  onError: (error: AxiosError<VerifyOTPError>) => void;
}) =>
  useMutation<VerifyOTPSuccess, AxiosError<VerifyOTPError>, VerifyOTPParams>({
    mutationFn: async (data) =>
      api
        .post(`${process.env.REACT_APP_API_LOGIN_OTP_VERIFY}`, data)
        .then((r) => r.data),
    onSuccess,
    onError,
  });

export const useMyAccountDetails = () =>
  useQuery<MyAccountDetailsSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["my-account"],
    queryFn: async ({ signal }) =>
      api
        .get(`${process.env.REACT_APP_API_GET_MY_ACCOUNT}`, { signal })
        .then((r) => r.data),
    staleTime: 10 * 60 * 1000,
    gcTime: 20 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

export const useResendOTP = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: ResendOTPSuccess) => void;
  onError: (error: AxiosError<VerifyOTPError>) => void;
}) =>
  useMutation<ResendOTPSuccess, AxiosError<ResendOTPError>, ResendOTPParams>({
    mutationFn: async (data) =>
      api
        .post(`${process.env.REACT_APP_API_LOGIN_OTP_RESEND}`, data)
        .then((r) => r.data),
    onSuccess,
    onError,
  });
